// Delays
export const tooltipDelay: number = 500

// Dimensions for various components

export const sidebarWidth: number = 350
export const maxSidebarWidth: number = 550

export const bottomBarHeight: number = 420
export const bottomBarHeightMargin: number = 5
export const leftSidebarToolsWidth: number = 55
export const leftSidebarWidth: number = sidebarWidth
export const leftSidebarSettingsWidth: number = 318
export const rightSidebarWidth: number = sidebarWidth
export const profileLegendWidth: number = 275
export const toolbarHeight: number = 55
export const topbarHeight: number = 50
export const headerHeight: number = topbarHeight + toolbarHeight

// Style constants for side bar components
export const wikiSideBarBaseZIndex = 800
export const sidebarAnimationDuration = 300
